<template>
    
    <div>
        <nav class="p-2 border-bottom border-primary">
            <b-button
            :pressed="false"
            class="typo-label"
            variant="link"
             @click="mostraListaImpianti"
            >Lista Impianti</b-button>
            <b-button
            :pressed="false"
            class="typo-label"
            variant="link"
            @click="mostraPaginaUtentiPendenti"
            >Lista Utenti in attesa validazione</b-button>
            <b-button
            :pressed="false"
            class="typo-label"
            variant="link"
             @click="mostraPaginaUtenti"
            >Lista Utenti</b-button>
            <b-button
            :pressed="false"
            class="typo-label"
            variant="link"
            @click="mostraPaginaCodiciPro"
            >Gestione Codici Pro</b-button>
            <b-button 
            :pressed="false"
            class="typo-label"
            variant="link"
            @click="mostraRiepilogo"
            >Riepilogo</b-button>
            <b-button v-if="this.$store.state.user.email=='aws.dev@beghelli.it' || this.$store.state.user.email=='aws.prod@beghelli.it'" 
            :pressed="false"
            class="typo-label"
            variant="link"
            @click="mostraMappa"
            >Mappa</b-button>
            <b-button
            :pressed="true"
            class="typo-label"
            variant="link"
            >Report Aldi</b-button>
        </nav>
        <Loader />
        <div v-if="!authorized && !pageloading" class="mt-4 center">
            <h3>Non sei autorizzato ad accedere a questa risorsa</h3>
        </div>
        <div v-if="!pageloading && this.aldiPlants!=null && this.aldiPlants.length>0  && authorized" class="animated fadeIn container-fluid">
            <b-row class="mt-2">
                <b-col lg="8" offset-lg="2">
                    <b-card borde-variant="primary" header-bg-variant="primary">
                        <template #header>
                            <h4 class="text-center">Riepilogo</h4>
                        </template>
                        <b-card-text>
                            <b-row>
                                <!-- <b-col lg="1"> -->
                                <b-col lg="2">
                                    <b>Totale Impianti: </b> {{this.totImpianti}}                                  
                                </b-col>
                                <b-col lg="2">
                                    <b>Totale Centrali: </b> {{this.totCentrali}}                                   
                                </b-col>
                                <b-col lg="2">
                                    <b>Totale Online: </b> {{this.totOnline}}
                                </b-col>                                
                                <b-col lg="2">
                                    <b>Totale Lampade: </b> {{this.totLampade}}
                                </b-col>
                                <b-col lg="2">
                                    <b>Totale Orfani: </b> {{this.totOrfani}}
                                </b-col> 
                                <b-col lg="2">
                                    <b>Totale non Acq: </b> {{this.totNonAcquisite}}
                                </b-col> 
                            </b-row>
                            <b-row>
                                <b-col lg="2">
                                    <b>Totale Errori: </b> {{this.totErrori}}
                                </b-col> 
                                <b-col lg="2">
                                    <b>Imp con dati incomp: </b> {{this.totErrPlantData}}
                                </b-col>                                          
                            </b-row>
                        </b-card-text>
                    </b-card>
                </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col class="center">
                    <b-table id="aldiTable" :per-page="rpp" :current-page="tabPage" sticky-header="500px" 
                        :striped="true" :hover="true" :items="filteredList" :fields="tableFields" 
                        :outlined="true" @row-clicked="selImpianto" sort-icon-left
                    >
                        <template v-slot:cell(indice)="data">
                           <strong>{{data.value}}</strong><br/>
                            {{data.index+1}}
                        </template>
                        <template v-slot:cell(plantname)="data">
                            <strong>{{data.value}}</strong><br/>
                            {{clienteImp(data.item)}}
                        </template>
                        <template v-slot:cell(plantType)="{ item: item }">
                            <strong>{{getPlantType(item)}}</strong>
                        </template>
                        <template v-slot:cell(installer)="{ item: item }">
                            {{installerImp(item)}}<br/>
                            {{emailInstallerImp(item)}}
                        </template>
                        <template v-slot:cell(plantTechnology)="{ item: item }">
                            <strong>{{getTechnology(item)}}</strong>
                        </template>
                        <template v-slot:cell(installationDate)="{ item: item }">
                            {{getInstallationDate(item)}}
                        </template>
                        <template v-slot:cell(tipoCentr)="{ item: item }">
                            <strong>{{getTipoCentrale(item)}}</strong>
                        </template>
                        <template v-slot:cell(statoCentr)="{ item: item }">
                            <strong>{{getStatoCentrale(item)==true? "ON LINE":"OFF LINE"}}</strong>
                        </template>
                        <template v-slot:cell(address)="data">
                            <strong>{{data.value.city}} ({{data.value.prov}})</strong><br/>
                            {{data.value.street}} {{data.value.housenumber}}
                        </template>
                        <template v-slot:cell(controlunits)="{ item: item }">
                            <strong>{{ countCent(item)}}</strong></br>
                        </template>
                        <template v-slot:cell(lamps)="{ item: item }">
                            <strong>{{ countLamps(item) }}</strong>
                        </template>
                        <template v-slot:cell(orphans)="{ item: item }">
                            <strong>{{ countOrphans(item) }}</strong>
                        </template>
                        <template v-slot:cell(errori)="data">
                            <strong :class="{'withError': (data.value > 0)}">{{data.value}}</strong> 
                        </template>
                    </b-table>
                </b-col>
            </b-row>    
            <b-row class="mt-6">
                <b-col>
                    <b-navbar v-if="userAllPlants != null && userAllPlants.length > 0" type="light" class="bottomNav"> 
                        <b-nav-text class="mx-auto">
                            <span class="totLabel">Totale records filtrati: {{filteredList.length}}</span>
                            <b-pagination
                                v-model="tabPage"
                                :total-rows="filteredList.length"
                                :per-page="rpp"
                                aria-controls="ntoTable"
                                ></b-pagination>
                        </b-nav-text>
                    </b-navbar>  
                </b-col>
            </b-row>     


        </div>
        
    </div>

</template>

<script>

import { Auth } from 'aws-amplify'
import { API } from 'aws-amplify'
//import * as Axios from 'axios'

import AddPlant from '@/components/AddPlant'
import NtoGraficoImpianti from '@/components/NTOGraficoImpianti'
import { mapState, install } from 'vuex';


import router from '../router/approuter'
import {showAt, hideAt} from 'vue-breakpoints'
import moment from 'moment'

export default {
    name: 'NTOAldi',
    components: {
        AddPlant,
        hideAt, 
        showAt,
        NtoGraficoImpianti
    },    
    props: [],
    data() {
        return {
            totCentrali: 0,
            totOnline: 0,
            totLampade: 0,
            totOrfani: 0,
            totNonAcquisite: 0,
            totErrori: 0,
            totErrPlantData: 0,
            totImpianti: 0,
            userId: null,
            pageloading: true,
            authorized: false,
            dataLoaded: false,
            tabPage: 1,
            graficoPeriodo: '',
            keyGraph:0,
            rpp: 100,
            tableFields: [
                {
                    key: 'indice',
                    label: 'Indice'
                },
                {
                    key: 'plantname',
                    label: 'Nome',
                    sortable: true
                },
                {
                    key: 'plantType',
                    label: 'Tipo Impianto',
                    sortable: true,
                    sortByFormatted: true,
                    formatter: 'plantTypeSort'

                }, 
                {
                    key: 'installer',
                    label: 'Installatore'
                },
                {
                    key: 'installationDate',
                    label: 'Data di creazione',
                    sortable: true,
                    sortByFormatted: true,
                    formatter: 'dateSort'
                },
                {
                    key: 'plantTechnology',
                    label: 'Tecnologia Impianto',
                    sortable: true,
                    sortByFormatted: true,
                    formatter: 'plantTechnologySort'

                }, 
                {
                    key: 'tipoCentr',
                    label: 'Tipo Centrale',
                },   
                {
                    key: 'statoCentr',
                    sortable: true,
                    sortByFormatted: true,
                    label: 'Stato Centrale',
                    formatter: 'centStateSort'
                },   
                {  
                    key: 'address',
                    label: 'Indirizzo',
                },
                {
                    key: 'controlunits',
                    label: 'Numero Centrali',
                    sortable: true,
                    sortByFormatted: true,
                    formatter: 'centSort'
                },
                {
                    key: 'lamps',
                    label: 'Numero Lampade',
                    sortable: true,
                    sortByFormatted: true,
                    formatter: 'lampSort'
                },
                {
                    key: 'orphans',
                    label: 'Numero orfani',
                    sortable: true,
                    sortByFormatted: true,
                    formatter: 'orphanSort'
                },
                {
                    key: 'errori',
                    label: 'Errori',
                    sortable: true,
                    sortByFormatted: true,
                    formatter: 'countErrors'
                }
            ]
        }
    },
    created() {
        // if (!this.$store.state.connecting && this.$store.state.socket != null && this.$store.state.socket.isConnected) {
        //     const usertype = this.$store.getters.userType;
        //     console.log("nto SUMMARY launch loadplants, " + usertype);
        //     if (usertype != 'admin') {
        //         this.authorized = false;
        //         this.pageloading = false;
        //     } else {
        //         this.authorized = true;
        //         this.pageloading = true;
        //         this.loadSummaryPlants();
        //     }
        // }               
    },

    mounted() {
        
        if (!this.$store.state.connecting && this.$store.state.socket != null && this.$store.state.socket.isConnected) {
            const usertype = this.$store.getters.userType;
            console.log("nto SUMMARY launch loadplants, " + usertype);
            if (usertype != 'admin') {
                this.authorized = false;
                this.pageloading = false;
            } else {
                this.authorized = true;
                this.pageloading = true;
                this.loadSummaryPlants();
            }
        }
    },
    updated() {
        if (this.userAllPlants==null && !this.$store.state.connecting && this.$store.state.socket != null && this.$store.state.socket.isConnected) {
           console.log("updated nto summary", this.userAllPlants);
        }
    },
    computed: {
        ...mapState(['loading']),

        filteredList() {
            console.log("chiamata filteredList ", this.advancedFilters, " userAllPlants: ", this.userAllPlants);
            return this.aldiPlants;
        },

        graphPeriods() {
            var periods = [];
            var date = this.moment(new Date()).startOf('year');
            for (var i=0; i< 20; i++) {
                periods.push(date.format('YYYY'));
                date.subtract(1,'year');
            }
            periods.unshift({text:this.$t("graph.last_year"), value:''});
            return periods;
        },

        //All plants
        userAllPlants() {
            // console.log("computed");
            return this.$store.state.userSummaryPlants;
        },

        emptyAllPlants() {
            return (this.emptyCentPlants.length + this.emptyBlePlants.length)
        },


        //ble plants
        bleAllPlants() {
            return this.userAllPlants.filter((item) => {
                    return (item.technology=='bluetooth')
            })
        },

        emptyBlePlants() {
            return this.userAllPlants.filter((item) => {
                    return (item.technology=='bluetooth' && (item.ble_lamps==null || item.ble_lamps.length==0))
            })
        },

        aldiPlants() {
            console.log("aldiPlants<-userAllPlants ", this.userAllPlants);
            return this.userAllPlants.filter((item) => {
                return (item.plantname.toUpperCase().includes("ALDI"))                       
            })

        },

        activeBlePlants() {
            return this.userAllPlants.filter((item) => {
                    return (item.technology=='bluetooth' && (item.ble_lamps!=null && item.ble_lamps.length>0))
            })
        },

        activeBleProPlants() {
            return this.userAllPlants.filter((item) => {
                    return (item.technology=='bluetooth' && (item.ble_lamps!=null && item.ble_lamps.length>0) && item.plant_type=="pro")
            })
        },

        activeBleBasicPlants() {
            return this.userAllPlants.filter((item) => {
                    return (item.technology=='bluetooth' && (item.ble_lamps!=null && item.ble_lamps.length>0) && item.plant_type=="basic")
            })
        },

        activeBleItPlants() {
            return this.userAllPlants.filter((item) => {
                    return (item.technology=='bluetooth' && (item.ble_lamps!=null && item.ble_lamps.length>0) && item.address.country=="IT")
            })
        },

        activeBleEstPlants() {
            return this.userAllPlants.filter((item) => {
                    return (item.technology=='bluetooth' && (item.ble_lamps!=null && item.ble_lamps.length>0) && item.address.country!="IT")
            })
        },

        //cent plants
        centAllPlants() {
            return this.userAllPlants.filter((item) => {
                    return (item.technology!='bluetooth')
            })
        },

        emptyCentPlants() {
            return this.userAllPlants.filter((item) => {
                    return (item.technology!='bluetooth' && (item.controlunits==null || item.controlunits.length==0))
            })
        },

        activeCentPlants() {
            return this.userAllPlants.filter((item) => {
                    return (item.technology!='bluetooth' && (item.controlunits!=null && item.controlunits.length>0))
            })
        },

        activeCentProPlants() {
            return this.userAllPlants.filter((item) => {
                    return (item.technology!='bluetooth' && (item.controlunits!=null && item.controlunits.length>0) && item.plant_type=="pro")
            })
        },

        activeCentBasicPlants() {
            return this.userAllPlants.filter((item) => {
                    return (item.technology!='bluetooth' && (item.controlunits!=null && item.controlunits.length>0) && item.plant_type=="basic")
            })
        },

        activeCentItPlants() {
            return this.userAllPlants.filter((item) => {
                    return (item.technology!='bluetooth' && (item.controlunits!=null && item.controlunits.length>0) && item.address.country=="IT")
            })
        },

        activeCentEstPlants() {
            return this.userAllPlants.filter((item) => {
                    return (item.technology!='bluetooth' && (item.controlunits!=null && item.controlunits.length>0) && item.address.country!="IT")
            })
        }

        },  
     watch: {
        loading(val,oldval) {
            console.log("loading changed:" + val);
            if (val == false) {
                console.log("userSummaryPlants: ", this.$store.state.userSummaryPlants);
                if(this.$store.state.userSummaryPlants==null)
                {
                    this.loadSummaryPlants();
                }
                else
                {
                    const usertype = this.$store.getters.userType;
                    if (usertype != 'admin') {
                        this.authorized = false;
                        this.pageloading = false;
                        console.log("not autorized");
                    } else {
                        this.authorized = true;
                        this.pageloading = false
                        this.calcolaRiepilogo();
                        //console.log("userType: ", usertype);
                        //console.log("caricato", this.userAllPlants);
                        //console.log("solo ALdi", this.aldiPlants);
                    }   
                }
            }
        }
    },        
    methods: {

        //funzione che viene richiamata in mounted() e prepara le variabili di riepilogo
        calcolaRiepilogo() {
            console.log("Calcolo riepilogo di: ", this.filteredList);
            //azzera le variabili:
            this.totCentrali = 0;
            this.totLampade = 0;
            this.totNonAcquisite = 0;
            this.totOrfani = 0;
            this.totErrori = 0;
            this.totErrPlantData = 0;
            this.totImpianti = this.filteredList.length;
            for(const elem of this.filteredList) {
                if (elem.cus_details != null) {
                    this.totCentrali += elem.cus_details.length;
                    for (const el of elem.cus_details) { 
                        if (el.cu_connected == true) this.totOnline++;
                        //se manca questo dato
                        if (!isNaN(el.num_lamp_found)) {
                            this.totLampade += el.num_lamp_found;
                        } else {
                            console.log("plant: ", elem);
                            this.totErrPlantData++; //segnalo solo qui perché tipicamente se c'è il problema su num_lamp_found, ci sono anche gli altri
                        }
                        //se tutte le lampade installate sono orfane, rientrano nel contatore di 'non acquisite'
                        if (el.num_lamp_found == el.num_nodi_orfani) {
                            if (!isNaN(el.num_nodi_orfani)) {
                                this.totNonAcquisite += el.num_nodi_orfani;
                            }                           
                        } else {
                            if (!isNaN(el.num_nodi_orfani)) {
                                this.totOrfani += el.num_nodi_orfani;
                            }                            
                        }
                        if (!isNaN(el.num_lamp_error)) {
                            this.totErrori += el.num_lamp_error;
                        }                       
                    }
                }
            }  
        },

        mostraListaImpianti() {
            router.push({ name: 'NTOHome'})
        },

        loadSummaryPlants () {
            this.$store.dispatch('loadSummaryPlantsPost',{userId: this.$store.state.user.username});
        },

        mostraPaginaUtenti() {
            router.push({ name: 'NTOUsers'})
        },

        mostraPaginaUtentiPendenti() {
            router.push({ name: 'NTOPendingUsers'})
        },

        mostraPaginaCodiciPro() {
            router.push({ name: 'NTOProCodes'})
        },

        mostraRiepilogo() {
            router.push({ name: 'NTOSummary'})
        },

        mostraAldi() {
            router.push({ name: 'NTOAldi'})
        },
        mostraMappa() {
            router.push({ name: 'NTOPlantsMap'})
        },

        selImpianto(item,index,ev) {
            console.log("selezionato impianto",item,index,ev);

            this.$store.state.currentPlant = item;
            this.$store.state.userLastPlants = [item];
            console.log('ora last plants =', this.$store.state.userLastPlants)
            router.push({ name: 'HomeImpianto', params: { pid: item.id } })

        },

        cuAllPlants()
        {
            var allCu=[];
            for(var k=0;k<this.centAllPlants.length;k++)
                if(this.getCuPlant(this.centAllPlants[k])!=null)
                {
                    allCu=allCu.concat(this.getCuPlant(this.centAllPlants[k]));
                }
            return allCu;    
        },

        cuLampsAllPlants()
        {
            var allCuLamps=0;
            for(var k=0;k<this.cuAllPlants().length;k++)
            {
                if(this.cuAllPlants()[k].num_lamp_found!=null)
                {
                    allCuLamps=allCuLamps + this.cuAllPlants()[k].num_lamp_found;
                }
            }
            return allCuLamps;    
        },

        cuEmergencyLampsAllPlants()
        {
            var allCuEmergencyLamps=0;
            for(var k=0;k<this.activeCentPlants.length;k++)
            {
                for(var n=0;n<this.activeCentPlants[k].cus_details.length;n++)
                    {
                        var cus=this.activeCentPlants[k].cus_details[n];
                        if(cus.lamps_id!=null)
                        {
                            allCuEmergencyLamps=allCuEmergencyLamps+ cus.lamps_id.length;
                        }
                    }
                
            }
            return allCuEmergencyLamps;    
        },

        cuLightingLampsAllPlants()
        {
            var allCuLightingLamps=0;
            for(var k=0;k<this.activeCentPlants.length;k++)
            {
                for(var n=0;n<this.activeCentPlants[k].cus_details.length;n++)
                    {
                        var cus=this.activeCentPlants[k].cus_details[n];
                        if(cus.lamps_illum_id!=null)
                        {
                            allCuLightingLamps=allCuLightingLamps+ cus.lamps_illum_id.length;
                        }
                    }
                
            }
            return allCuLightingLamps;    
        },

        cuOthersAllPlants()
        {
            var allCuOthers=0;
            for(var k=0;k<this.activeCentPlants.length;k++)
            {
                for(var n=0;n<this.activeCentPlants[k].cus_details.length;n++)
                    {
                        var cus=this.activeCentPlants[k].cus_details[n];
                        if(cus.lamps_altro_id!=null)
                        {
                            allCuOthers=allCuOthers+ cus.lamps_altro_id.length;
                        }
                    }
                
            }
            return allCuOthers;    
        },

        emergencyPlants()
        {
            var emergencyPlants=0;
            for(var k=0;k<this.activeCentPlants.length;k++)
            {
                var cuEm=0;
                for(var n=0;n<this.activeCentPlants[k].cus_details.length;n++)
                    {
                        var cus=this.activeCentPlants[k].cus_details[n];
                        if(cus.lamps_id!=null)
                        {
                            if(cus.lamps_id.length>0 && (cus.lamps_illum_id==null || cus.lamps_illum_id.length==0))
                            cuEm++;
                        }
                    }
                if(cuEm>0)
                 emergencyPlants++;    
                
            }
            return emergencyPlants;    
        },

        emergencyPlantsLamps()
        {
        
            var emergencyPlantLamps=0;
            for(var k=0;k<this.activeCentPlants.length;k++)
            {
                for(var n=0;n<this.activeCentPlants[k].cus_details.length;n++)
                    {
                        var cus=this.activeCentPlants[k].cus_details[n];
                        if(cus.lamps_id!=null && (cus.lamps_illum_id==null || cus.lamps_illum_id.length<=0))
                        {
                            emergencyPlantLamps=emergencyPlantLamps+ cus.lamps_id.length;
                        }
                    }
                
            }
            return emergencyPlantLamps;    
        
        },

        lightingPlants()
        {
            var lightingPlants=0;
            for(var k=0;k<this.activeCentPlants.length;k++)
            {
                var cuIll=0;
                for(var n=0;n<this.activeCentPlants[k].cus_details.length;n++)
                    {
                        var cus=this.activeCentPlants[k].cus_details[n];
                        if(cus.lamps_illum_id!=null)
                        {
                            if(cus.lamps_illum_id.length>0 && (cus.lamps_id==null || cus.lamps_id.length==0))
                            cuIll++;
                        }
                    }
                if(cuIll>0)
                lightingPlants++;      
                
            }
            return lightingPlants;    
        },

        lightingPlantsLamps()
        {
        
            var lightingPlantLamps=0;
            for(var k=0;k<this.activeCentPlants.length;k++)
            {
                for(var n=0;n<this.activeCentPlants[k].cus_details.length;n++)
                    {
                        var cus=this.activeCentPlants[k].cus_details[n];
                        if(cus.lamps_illum_id!=null && (cus.lamps_id==null || cus.lamps_id.length<=0))
                        {
                            lightingPlantLamps=lightingPlantLamps+ cus.lamps_illum_id.length;
                        }
                    }
                
            }
            return lightingPlantLamps;    
        
        },

        mixedPlants()
        {
            var mixedPlants=0;
            for(var k=0;k<this.activeCentPlants.length;k++)
            {   
                var cuMix=0;
                for(var n=0;n<this.activeCentPlants[k].cus_details.length;n++)
                    {
                        var cus=this.activeCentPlants[k].cus_details[n];
                        if(cus.lamps_id!=null && cus.lamps_illum_id!=null)
                        {
                            if(cus.lamps_id.length>0 && cus.lamps_illum_id.length>0)
                            cuMix++;
                        }
                    }
                if(cuMix>0)
                 mixedPlants++;      
                
            }
            return mixedPlants;    
        },

        emergencyMixedPlantsLamps()
        {
        
            var emergencyMixedPlantLamps=0;
            for(var k=0;k<this.activeCentPlants.length;k++)
            {
                for(var n=0;n<this.activeCentPlants[k].cus_details.length;n++)
                    {
                        var cus=this.activeCentPlants[k].cus_details[n];
                        if(cus.lamps_id!=null && cus.lamps_illum_id!=null && cus.lamps_illum_id.length>0)
                        {
                            emergencyMixedPlantLamps=emergencyMixedPlantLamps+ cus.lamps_id.length;
                        }
                    }
                
            }
            return emergencyMixedPlantLamps;    
        
        },

        emergencyMixedPlantsLamps()
        {
        
            var emergencyMixedPlantLamps=0;
            for(var k=0;k<this.activeCentPlants.length;k++)
            {
                for(var n=0;n<this.activeCentPlants[k].cus_details.length;n++)
                    {
                        var cus=this.activeCentPlants[k].cus_details[n];
                        if(cus.lamps_id!=null && cus.lamps_illum_id!=null && cus.lamps_illum_id.length>0)
                        {
                            emergencyMixedPlantLamps=emergencyMixedPlantLamps+ cus.lamps_id.length;
                        }
                    }
                
            }
            return emergencyMixedPlantLamps;    
        
        },

        bleLampsAllPlants()
        {
            var allBleLamps=[];
            for(var k=0;k<this.bleAllPlants.length;k++)
                if(this.bleAllPlants[k].ble_lamps!=null)
                {
                    allBleLamps=allBleLamps.concat(this.bleAllPlants[k].ble_lamps);
                }
            return allBleLamps;    
        },

        cuCablecomAllPlants()
        {
            return this.cuAllPlants().filter((item) => {
                    return (item.cutype=="cablecom")
            })
        },

        cuLogicaAllPlants()
        {
            return this.cuAllPlants().filter((item) => {
                    return (item.cutype=="logica")
            })
        },

        cuLogicaFMAllPlants()
        {
            return this.cuAllPlants().filter((item) => {
                    return (item.cutype=="logicafm")
            })
        },

        cuSicuroAllPlants()
        {
            return this.cuAllPlants().filter((item) => {
                    return (item.cutype=="sicuro")
            })
        },

        cuGatewayAllPlants()
        {
            return this.cuAllPlants().filter((item) => {
                    return (item.cutype=="blegateway")
            })
        },

        getCuPlant(plant) {
            if(plant!=null)
            {
                if (plant.controlunits != null) 
                  return plant.controlunits;
            }
        },

      
        getTipoImpianto(imp) {
            if (imp!=null)
            {
                if(imp.technology == "bluetooth") 
                {
                    return "Bluetooth";
                }
                else {
                    return "Centralizzato";
                }  
            } 
        },

        selectedMonth(value) {
            console.log("selected month",value);
            this.graficoPeriodo = value.month; 
        },

          //------------------------------------------------------------------------------------------------------------------
        //
        // function: countLamps(plant)
        //
        // output: 
        //------------------------------------------------------------------------------------------------------------------
        countLamps(plant) {
            if(plant!=null)
            {
                if (this.getTechnology(plant) == "Centralizzato")  {
                    if (plant.controlunits == null) return 0;
                    var nlamp = plant.controlunits.reduce(function(acc,unit) {
                        return acc + (unit.num_lamp_found || 0);
                    },0);
                    return nlamp;
                }
                else {
                    if (plant.ble_lamps == null) return 0;
                    return plant.ble_lamps.length;
                }
            }
        },

        countOrphans(plant) {
            if(plant!=null)
            {
                    if (plant.cus_details == null) return 0;
                    var norphan = plant.cus_details.reduce(function(acc,unit) {
                        return acc + (unit.num_nodi_orfani || 0);
                    },0);
                    return norphan;
            }
        },

        countCent(plant) {
            if(plant!=null)
            {
                if (plant.controlunits == null) return 0;
                return plant.controlunits.length;
            }
        },

        // cuAllPlants()
        // {
        //     var allCu=[];
        //     for(var k=0;k<this.centAllPlants.length;k++)
        //         if(this.getCuPlant(this.centAllPlants[k])!=null)
        //         {
        //             allCu=allCu.concat(this.getCuPlant(this.centAllPlants[k]));
        //         }
        //     return allCu;    
        // },

        // bleLampsAllPlants()
        // {
        //     var allBleLamps=[];
        //     for(var k=0;k<this.bleAllPlants.length;k++)
        //         if(this.bleAllPlants[k].ble_lamps!=null)
        //         {
        //             allBleLamps=allBleLamps.concat(this.bleAllPlants[k].ble_lamps);
        //         }
        //     return allBleLamps;    
        // },

        // cuCablecomAllPlants()
        // {
        //     return this.cuAllPlants().filter((item) => {
        //             return (item.cutype=="cablecom")
        //     })
        // },

        // cuLogicaAllPlants()
        // {
        //     return this.cuAllPlants().filter((item) => {
        //             return (item.cutype=="logica")
        //     })
        // },

        // cuLogicaFMAllPlants()
        // {
        //     return this.cuAllPlants().filter((item) => {
        //             return (item.cutype=="logicafm")
        //     })
        // },

        // cuSicuroAllPlants()
        // {
        //     return this.cuAllPlants().filter((item) => {
        //             return (item.cutype=="sicuro")
        //     })
        // },

        // cuGatewayAllPlants()
        // {
        //     return this.cuAllPlants().filter((item) => {
        //             return (item.cutype=="gatewayble")
        //     })
        // },

        // getCuPlant(plant) {
        //     if(plant!=null)
        //     {
        //         if (plant.controlunits != null) 
        //           return plant.controlunits;
        //     }
        // },

      
        // countLamps(units) {
        //     if (units == null) return 0;
        //     var nlamp = units.reduce(function(acc,unit) {
        //         return acc + (unit.num_lamp_found || 0);
        //     },0);
        //     return nlamp;
            
        // },

        clienteImp(imp) {
            if (imp.plant_users == null) return "";
            let cli = imp.plant_users.filter(function(u) {
                return u.role == 'client'
            });
            if (cli == null || cli.length == 0) return ""
            return cli[0].nome;
        },

        installerImp(imp) {
            if (imp.plant_users == null) return "";
            let cli = imp.plant_users.find(function(u) {
                return u.role == 'installer'
            });
            if (cli == null ) return ""
            //console.log("intaller",cli);
            if (cli.nome == null) {
            const allUsers = this.$store.state.allUsers;
            if (allUsers != null) {
                let installer = allUsers.find(u => {
                    //console.log("user-->" + u.id + " " + u.businessname+", " + cli[0].userid);
                    return u.id == cli.userid;
                });
                if (installer != null) {
                    if (installer.businessname != null && installer.businessname != '') {
                        cli.nome = installer.businessname;
                        return installer.businessname;
                    } 
                    cli.nome =installer.surname + ' ' + installer.name;
                    return installer.surname + ' ' + installer.name;
                }
            }
            }
            return cli.nome || "N.D.";
        },

        emailInstallerImp(imp) {
            if (imp.plant_users == null) return "";
            let cli = imp.plant_users.find(function(u) {
                return u.role == 'installer'
            });
            if (cli == null ) return ""
            //console.log("intaller",cli);
            if (cli.email == null) {
            const allUsers = this.$store.state.allUsers;
            if (allUsers != null) {
                let installer = allUsers.find(u => {
                    //console.log("user-->" + u.id + " " + u.businessname+", " + cli[0].userid);
                    return u.id == cli.userid;
                });
                if (installer != null) {
                    //console.log("installer->",installer);
                    //if (installer.email != null && installer.email != '') {
                        cli.email = installer.username;
                        return installer.username;
                    //} 
                }
            }
            }
            return cli.email || "N.D.";
        },

        dateSort(value,key,item) {
            if(item.regdate!=null)
                return (item.regdate > 0) ? item.regdate : 0
        },

        lampSort(value,key,item) {
            return (this.countLamps(item) > 0) ? this.countLamps(item) : 0
        },

        orphanSort(value,key,item) {
            return (this.countOrphans(item) > 0) ? this.countOrphans(item) : 0
        },

        centSort(value,key,item) {
            return (this.countCent(item) > 0) ? this.countCent(item) : 0
        },

        plantTechnologySort(value,key,item) {
            return (item.technology=="bluetooth")? 1 : 0
        },

        centStateSort(value,key,item) {
            if(item.cus_details!=null && item.cus_details.length >0)
              if(item.cus_details[0].cu_connected!=null)
                return (item.cus_details[0].cu_connected==true)? 1 : 0
              else
                return 0 
        },

        plantTypeSort(value,key,item) {
            return (item.plant_type=="pro")? 1 : 0
        },

        countErrors(value,key,item) {

            if (item == null || item.controlunits == null) return 0;
            var nlamp = item.controlunits.reduce(function(acc,unit) {
                return acc + (unit.num_lamp_error || 0);
            },0);
            return (nlamp > 0) ? nlamp : 0

        //console.log("countErrors for:",a,b,c,d);
        /*if (units == null) return 0;
        var nlamp = units.reduce(function(acc,unit) {
            return acc + unit.num_lamp_error;
        },0);
        //if (nlamp > 0) return "<span style=\"color: red\">" + nlamp + "</span>";
        //return "0";
        return (nlamp > 0) ? nlamp : 0;*/
        //return "XX"
        
        },

        //------------------------------------------------------------------------------------------------------------------
        //
        // function: getTipoImpianto(<record di Plants>)
        //
        // output: se nel record di Plants non  esiste il campo 'technology', introdotto con i nuovi impianti Bluetooth,
        // allora si assume che sia un impianto 'Centralizzato'
        //------------------------------------------------------------------------------------------------------------------
        getTechnology(imp) {
            if (imp!=null)
            {
                if(imp.technology == "bluetooth") 
                {
                    return "Bluetooth";
                }
                else {
                    return "Centralizzato";
                }  
            } 
        },

        getPlantType(imp) {
            if (imp!=null)
            {
                if(imp.plant_type == "pro") 
                {
                    return "Pro";
                }
                else {
                    return "Basic";
                }  
            } 
        },


        getInstallationDate(imp) {
            return moment(imp.regdate).format("DD MMM YYYY");
        },


        //------------------------------------------------------------------------------------------------------------------
        //
        // function: getTipoCentrale(<record di Plants>)
        //
        // output: l'elenco delle tipologie di centrale presenti nell'impianto, come risulta dall'array 'controlunits'
        // di Plants
        //------------------------------------------------------------------------------------------------------------------
        getTipoCentrale(imp) { 
            if (imp.cus_details == null || imp.cus_details.lenght == 0 || imp.cus_details == "") {
                return "nessuna";
            } else {
                //per ogni controlunits presente nell'impianto
                let risp = ""
                imp.cus_details.forEach( (value) => { 
                    risp=risp+value.cu_type+"_"+value.cu_id + "\n";
                } )
                return risp;
            }
        },   

        getStatoCentrale(imp) { 
            if (imp.cus_details == null || imp.cus_details.lenght == 0 || imp.cus_details == "") {
                return "";
            } else {
                //per ogni controlunits presente nell'impianto
                let risp;
                imp.cus_details.forEach( (value) => { 
                    risp=value.cu_connected;
                } )
                return risp;
            }
        },   

        
    }
    

}
</script>